<template>
  <div>
    <!-- 直降价格 -->
    <div class="straight_down_price">
      <div class="start_price">
        <div class="left_price">
          <div class="sale_price">
            <span>￥</span><b>{{ calculationPrice(nowAcvitity.price).b }}</b>
            <span> {{ calculationPrice(nowAcvitity.price).s }}</span>
          </div>
          <div class="origin_price">
            <span>券后价格</span><b>￥{{ dealPrice(nowAcvitity.promotionPrice) }}</b>
          </div>
        </div>
        <div class="right_time">
          <div class="time1">
            {{ courseBaseData.realSales + courseBaseData.initialSales }}人已抢购
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { priceCount, priceFilterFloat } from '../../utils/tools';

export default {
  components: {},
  data() {
    return {
      times: '', // 时间展示
      timeType: 0, // 1 大于3天 2小于3天
      timers: null, // 定时器
    };
  },
  props: {
    nowAcvitity: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapState(['courseBaseData']),
  },
  watch: {},
  created() {},
  mounted() {},
  destroyed() {
    clearInterval(this.timers);
  },
  methods: {
    // 价格小数位处理
    calculationPrice(price) {
      return priceCount(price);
    },
    dealPrice(price) {
      return priceFilterFloat(price);
    },
  },
};
</script>
<style scoped lang="scss">
// 直降
.straight_down_price {
  width: 100%;
  height: 108px;
  .start_price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 108px;
    background: url('../../assets/img/productDetail/coupon_bg.png') no-repeat;
    background-size: 100%;

    .left_price {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 108px;
      padding-left: 36px;
      .sale_price {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 40px;
        // padding-top: 30px;

        span {
          color: #fff;
          font-size: 29px;
        }
        b {
          color: #fff;
          font-size: 33px;
        }
      }
      .origin_price {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 51px;
        margin-left: 13px;
        padding: 0 15px;
        background: #fff;
        border-radius: 25px 25px 25px 4px;

        span,
        s {
          color: #fe5106;
          font-size: 22px;
        }
        b{
          color: #fe5106;
          font-size: 33px;
        }
      }
    }
    .right_time {
      padding-right: 29px;
      .time1 {
        color: #ff6c02;
        font-size: 22px;
        line-height: 28px;
        text-align: center;
      }
    }
  }
}
</style>
